import {
  usersLicensesStarted,
  usersLicensesSucceeded,
  usersLicensesFailure,
  usersRenewableLicensesSucceeded,
  usersRenewableLicensesStarted,
  usersRenewableLicensesFailure,
  usersTaxableLicensesSucceeded,
  usersTaxableLicensesStarted,
  usersTaxableLicensesFailure,
} from './dashboardSlice';
import { selectCurrentIDToken } from '../auth/authSelectors';

export const getUsersLicensesAsync = () => {
  return async (dispatch, getState, api) => {
    dispatch(usersLicensesStarted());
    const state = getState();
    const accessToken = selectCurrentIDToken(state);

    const fetchLicenses = async (
      accumulatedLicenses = [],
      contToken = null
    ) => {
      try {
        const response = await api.getUsersLicensesAsync(
          accessToken,
          contToken
        );

        if (response.status === 200) {
          const { data } = response;
          const newLicenses = [...accumulatedLicenses, ...data.licenses];

          if (data.contToken) {
            // Recursively call the function if contToken exists
            return fetchLicenses(newLicenses, data.contToken);
          } else {
            // All data fetched, dispatch success action
            dispatch(usersLicensesSucceeded(newLicenses));
          }
        } else {
          dispatch(
            usersLicensesFailure(
              'Something went wrong while fetching licenses.'
            )
          );
        }
      } catch (error) {
        dispatch(
          usersLicensesFailure('Something went wrong while fetching licenses.')
        );
      }
    };

    await fetchLicenses();
  };
};

export const getUsersRenewableLicensesAsync = () => {
  return async (dispatch, getState, api) => {
    dispatch(usersRenewableLicensesStarted());
    try {
      const accessToken = selectCurrentIDToken(getState());
      const response = await api.getUsersRenewableLicensesAsync(accessToken);
      if (response.status === 200) {
        dispatch(usersRenewableLicensesSucceeded(response?.data));
      } else {
        dispatch(
          usersRenewableLicensesFailure(
            'Something went wrong while fetching renewable licneses.'
          )
        );
      }
    } catch (error) {
      dispatch(
        usersRenewableLicensesFailure(
          'Something went wrong while fetching renewable licneses.'
        )
      );
    }
  };
};

export const getUsersActionableTaxPaymentPeriodsAsync = () => {
  return async (dispatch, getState, api) => {
    dispatch(usersTaxableLicensesStarted());
    try {
      const response = await api.getTaxPaymentPeriods(getState());
      if (response.status === 200) {
        // filter result to only include actionable licenses (empty array if no match)
        const actionablePeriods = response?.data?.paymentPeriods?.filter(
          (period) => {
            period.licenses = period.licenses.filter(
              (license) => license.isActionable
            );
            return period.licenses.length > 0;
          }
        );

        dispatch(usersTaxableLicensesSucceeded(actionablePeriods));
      } else {
        dispatch(
          usersTaxableLicensesFailure(
            'Something went wrong while fetching taxable license periods.'
          )
        );
      }
    } catch (error) {
      dispatch(
        usersTaxableLicensesFailure(
          'Something went wrong while fetching taxable license periods.'
        )
      );
    }
  };
};
